import React from 'react'
import styled from '@emotion/styled'
import { Flex } from 'lese'
import Navbar from 'Components/Navbar/Navbar'
import Modal from 'Components/Modal'
import { colors } from 'Constants'

import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'

const Wrapper = styled.div`
  position: relative;
  top: 0;
  background-color: ${colors.background};
`

const Main = styled.div`
  background-color: ${colors.mainBackground};
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`

export default ({ children }) => {
  return (
    <>
      <Flex column width="100%" height="100vh">
        <Navbar />
        <Wrapper>
          <Main>{children}</Main>
        </Wrapper>
      </Flex>
      <ToastContainer
        position="bottom-right"
        autoClose={6000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal />
    </>
  )
}
